<template>
  <a-modal width="700px" v-model="isShow" :title="title" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model
      ref="formDom"
      :model="formArticle"
      :rules="rulesArticle"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 19 }"
    >
      <a-form-model-item label="死链地址" prop="path">
        <a-input v-model.trim="formArticle.path" placeholder="请输入" />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { formArticle, rulesArticle } from '../business/filialeList'
import dialog from '@/composables/dialog'
import api from '@/api/'
import store from '@/store/'
const title = {
  Add: '新增',
  Edit: '编辑',
}

export default defineComponent({
  mixins: [dialog],
  props: {
    params: {
      type: Object,
      default: {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rulesArticle,
      title: title.Add,
      btnloading: false,
      formArticle: { ...formArticle },
    })
    watch(
      () => _this.params,
      async () => {
        state.formArticle = JSON.parse(JSON.stringify(_this.params))
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )
    onMounted(() => {
      state.formArticle.project = parseInt(_this.$route.query.project)
    })
    const methods = {
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          const data = { ...state.formArticle }
          if (valid) {
            if (_this.isEdit) {
              res = await api.deadLinksUpdate(data)
            } else {
              res = await api.deadLinksCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      },
    }
    return {
      ...toRefs(state),
      ...methods,
    }
  },
})
</script>
